import React from 'react';
import { motion } from 'framer-motion';
import StoreButtons from './StoreButtons';
import { useTranslation } from '../i18n/LanguageContext';

const HeroSection = () => {
  const { t } = useTranslation();
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
      },
    },
  };

  const mockupVariants = {
    hidden: { opacity: 0, x: 50, scale: 0.8 },
    visible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: {
        duration: 1,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-6 py-12 md:px-12 bg-light-bg">
      <div className="max-w-7xl w-full pt-0">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="flex flex-col gap-6 md:col-span-3"
          >
            <motion.h1
              variants={itemVariants}
              className="font-filson font-bold text-5xl md:text-6xl leading-tight text-gray-900"
            >
              {t('hero.title')}
            </motion.h1>

            <motion.p
              variants={itemVariants}
              className="font-filson font-medium text-xl text-gray-600 leading-relaxed"
            >
              {t('hero.subtitle')}
            </motion.p>

            <motion.p
              variants={itemVariants}
              className="font-filson font-medium text-base text-gray-500 leading-relaxed"
            >
              {t('hero.description')}
            </motion.p>

            {/* Store Buttons */}
            <motion.div variants={itemVariants} className="pt-4">
              <StoreButtons size="normal" />
            </motion.div>
          </motion.div>

          {/* Right Side - App Mockups */}
          <motion.div
            variants={mockupVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="hidden md:flex md:col-span-2 justify-center items-center gap-6 w-full"
          >
            <motion.div
              whileHover={{ y: -10 }}
              transition={{ duration: 0.3 }}
            >
              <img
                src="/assets/derkenar-actions.jpeg"
                alt="Derkenar Actions Mockup"
                style={{
                  width: '240px',
                  borderRadius: '32px',
                  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                  objectFit: 'cover',
                }}
              />
            </motion.div>
            <motion.div
              whileHover={{ y: -10 }}
              transition={{ duration: 0.3 }}
              style={{ marginTop: '40px' }}
            >
              <img
                src="/assets/derkenar-notespage.jpeg"
                alt="Derkenar Notes Page Mockup"
                style={{
                  width: '240px',
                  borderRadius: '32px',
                  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                  objectFit: 'cover',
                }}
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
